import styled from 'styled-components';
import { darken } from 'polished';
import colors from '~/styles/colors';

export const Container = styled.div`
  flex: 1;
  padding: 1rem 30rem;
`;

export const Report = styled.div`
  flex: 1;
  padding: 3rem 0;

  form {
    display: flex;
    flex-direction: column;
    label {
      color: ${colors.primary};
      padding: 1.2rem 0;
      font-weight: bold;
      font-size: 1.5rem;
    }
    input,
    select {
      background: white;
      border: 0;
      border-radius: 4px;
      height: 50px;
      padding: 0px 20px;
      color: #000;
      margin: 0 0 10px;
      font-size: 18px;
      width: 30%;

      &::placeholder {
        color: #999;
      }
    }
    button {
      margin-top: 1rem;
      height: 5rem;
      background-color: ${colors.primary};
      border-radius: 0.4rem;
      border: 0;
      color: #fff;
      font-size: 1.8rem;
      font-weight: bold;
      text-transform: uppercase;
      width: 30%;

      &:hover {
        background-color: ${darken(0.1, colors.primary)};
      }
    }
  }
  & + & {
    border-top: 1px solid #000;
  }
`;
